module.exports = __webpack_public_path__ + "static/media/white circle.f1116ae8.png";